import { useEffect, useMemo, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import NewsPage from "../news/NewsPage";
import { CATEGORY_ITEMS, normalize, getCategoryBySlug, SUBCATEGORY_SLUG_MAP } from "../../constants/categories";
import { getCategoryTree } from "../../api/apiHandler";

const Category = () => {
  const { slug } = useParams();
  const location = useLocation();
  const [tree, setTree] = useState([]);

  useEffect(() => {
    getCategoryTree()
      .then((res) => setTree(Array.isArray(res.data) ? res.data : []))
      .catch(() => setTree([]));
  }, []);

  const searchParams = new URLSearchParams(location.search);
  const stateQuery = searchParams.get("state") || undefined;

  // Resolve the slug → { category, categoryAliases, title, isSubcategory }
  const resolved = useMemo(() => {
    const normSlug = normalize(slug);

    // 1) Direct category (or alias) match
    const direct = getCategoryBySlug(slug);
    if (direct) {
      return {
        category: direct.category,
        categoryAliases: direct.aliases || [],
        title: direct.label,
        isSubcategory: false,
      };
    }

    // 2) Subcategory match → resolve its parent category
    const subName = SUBCATEGORY_SLUG_MAP[slug] || slug;
    const allSubs = tree.flatMap((cat) =>
      (cat.subcategories || []).map((sub) => ({ sub, parent: cat }))
    );
    const match = allSubs.find(({ sub }) => normalize(sub.name) === normalize(subName));

    if (match) {
      const parentName = normalize(match.parent.name);
      const parentItem = CATEGORY_ITEMS.find(
        (item) =>
          normalize(item.dbName) === parentName ||
          normalize(item.category) === parentName ||
          (item.aliases || []).map(normalize).includes(parentName)
      );

      return {
        category: parentItem ? parentItem.category : match.parent.name,
        categoryAliases: parentItem
          ? parentItem.aliases || []
          : [match.parent.name],
        title: match.sub.name,
        isSubcategory: true,
        subcategory: match.sub.name,
      };
    }

    // 3) Raw slug fallback
    return { category: slug, categoryAliases: [], title: slug, isSubcategory: false };
  }, [slug, tree]);

  return (
    <NewsPage
      category={resolved.category}
      categoryAliases={resolved.categoryAliases}
      subcategory={resolved.subcategory}
      includeEmptyCategory={false}
      state={stateQuery}
      title={resolved.title}
    />
  );
};

export default Category;